import hostname from "./domain";
import routes from "./routes";
import axios from "axios";
import getURLParams from "./Components/utils/getParams";

// export const mainDomain = "https://api.ezoneerp.com/gateway/inventoryserv/api/v1";

// export const rootDomain = "https://ezoneerp.com";
export const rootDomain = "https://core.ezoneerp.com";

// export const domain = "https://ezone-inventory.optisoft.com.ng";
export const domain = "https://sales.ezoneerp.com/";

export const mainDomain =
  "https://dev.ezoneapps.com/gateway/inventoryserv/api/v1";

const newHost =
  "https://gateway.ezoneapps.com:30002/ezone-api-inventory/api/v1";
const authHost =
  "https://gateway.ezoneapps.com:30002/ezone-api-authservice/api/v1";

class Services {
  static createItemGroup(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.createItemGroupRoute}`,
      data: payload.data,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static fetchItemGroupsByOrgId({ page, size, orgId }) {
    const params = getURLParams({ page, size });
    return axios({
      method: "GET",
      url: `${newHost}${routes.getItemGroupsByOrgId(orgId)}${params}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static fetchItemGroupNumber() {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getItemGroupNumber}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  // static fetchAllItemGroups(payload) {
  //   return axios({
  //     method: "GET",
  //     // url: `${newHost}${routes.getAllItemGroupRoute}`,
  //     url: `${newHost}${routes.getItemGroupsByOrgId(orgId)}${params}`,

  //     headers: {
  //       Authorization: `Bearer ${localStorage.invToken}`,
  //     },
  //   });
  // }

  static fetchAllItemGroups({ page, size, orgId }) {
    const params = getURLParams({ page, size });
    return axios({
      method: "GET",
      url: `${newHost}${routes.getItemGroupsByOrgId(orgId)}${params}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async updateItemGroups(payload) {
    return axios({
      method: "PUT",
      url: `${newHost}${routes.updateItemGroupRoute(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }
  static async deleteItemGroup(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.deleteItemGroup(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static fetchSingleItemGroup(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getSingleItemGroup(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async addWarehouse(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.addWarehouse}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async getAllWarehouse(payload) {
    const params = getURLParams(payload);
    return axios({
      method: "GET",
      url: `${newHost}${routes.getAllWarehouse}${params}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async fetchSingleWarehouse(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getSingleWarehouse(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async updateWarehouse(payload) {
    return axios({
      method: "PUT",
      url: `${newHost}${routes.updateWarehouse(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async deleteWarehouse(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.deleteWarehouse(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getAllItems(payload) {
    const params = getURLParams(payload);
    return axios({
      method: "GET",
      url: `${newHost}${routes.itemsRoute}${params}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getSingleItem(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.itemsRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async createItem(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.itemsRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async deleteItem(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.itemsRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async updateItem(payload) {
    return axios({
      method: "PUT",
      url: `${newHost}${routes.updateItem(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async getUserProfile(payload) {
    return axios({
      method: "GET",
      url: `${authHost}${routes.userProfileRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getUsersByOrg(payload) {
    return axios({
      method: "GET",
      url: `${authHost}${routes.userByOrgRoute(
        payload.orgId
      )}?start=0&limit=10`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getCustomers(payload) {
    const params = getURLParams(payload);
    return axios({
      method: "GET",
      url: `${newHost}${routes.customersRoute}${params}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async createCustomers(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.customersRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async editCustomers(payload) {
    return axios({
      method: "PUT",
      url: `${newHost}${routes.customersRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async deleteCustomers(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.customersRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async createVendors(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.vendorRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async getVendors(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.vendorRoute}/listAllVendors/${payload.page}/${payload.size}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async editVendors(payload) {
    return axios({
      method: "PUT",
      url: `${newHost}${routes.vendorRoute}/update/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async deleteVendors(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.vendorRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getAllInvoice(payload) {
    const params = getURLParams(payload);
    return axios({
      method: "GET",
      url: `${newHost}${routes.getInvoiceRoute}${params}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getInvoice(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.invoiceRoute}/${payload.id}`,
      /* url: `${hostname}/${routes.getSingleInvoice(payload.id)}`, */
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async createInvoice(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.invoiceRoute}/customer_id/${payload.id}/add_invoice`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async deleteInvoice(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.invoiceRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getPaymentInfo(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.paymentRoute}/${payload.id}/init_payment`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async makePayment(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.paymentRoute}/${payload.id}/pay`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async logout() {
    return axios({
      method: "POST",
      url: `${authHost}${routes.logoutRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  //create Receipt
  static async createReceipt(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.receiptRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getAllReceipt(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getAllReceiptsRoute}/${payload.page}/${payload.size}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async getSingleReceipt(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getSingleReceiptRoute(payload.id)}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async deleteReceipt(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.receiptRoute}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async issueItem(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.issueItemRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  // get all TRANSFAR ORDER
  static async getAllTransfarOrder(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getAllTransfarOrderRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  //create transfar order
  static async createTransfarOrder(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.addTransfarOrderRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  static async deleteTransferOrder(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.deleteTransferOrder}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  //add Adjustments
  static async createAdjustment(payload) {
    return axios({
      method: "POST",
      url: `${newHost}${routes.addAdjustmentsRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
      data: payload.data,
    });
  }

  //Adjustments List
  static async getAllAdjustments(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.adjustmentsListRoute}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken},`,
      },
    });
  }

  static async fetchSingleAdjustment(payload) {
    return axios({
      method: "GET",
      url: `${newHost}${routes.getSingleAdjustmentRoute(payload.id)}`,

      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }

  static async deleteAdjustment(payload) {
    return axios({
      method: "DELETE",
      url: `${newHost}${routes.deleteAdjustment}/${payload.id}`,
      headers: {
        Authorization: `Bearer ${localStorage.invToken}`,
      },
    });
  }
}

export default Services;

// /api/v1/add_transfer_orders
